import { useState } from 'react';

/**
 * Hook for managing the state of a hover event.
 * @example
 * const { isHovered, onMouseEnter, onMouseLeave } = useOnHover();
 * return (
 *   <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
 *     {isHovered ? 'Hovered' : 'Not hovered'}
 *   </div>
 * );
 */
export const useOnHover = () => {
  const [isHovered, setIsHovered] = useState(false);
  return {
    isHovered,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  };
};
